const skills = [
    {
        img: require("../assets/images/css.png"),
        alt: "css",
        text: "CSS"
    },
    {
        img: require("../assets/images/html.png"),
        alt: "css",
        text: "HTML"
    },
    {
        img: require("../assets/images/express.png"),
        alt: "express",
        text: "Express"
    },
    {
        img: require("../assets/images/jquery.png"),
        alt: "jquery",
        text: "jQuery"
    },
    {
        img: require("../assets/images/js.png"),
        alt: "js",
        text: "JavaScript"
    },
    {
        img: require("../assets/images/mongodb.png"),
        alt: "mongodb",
        text: "MongoDb"
    },
    {
        img: require("../assets/images/node.png"),
        alt: "node",
        text: "NodeJs"
    },
    {
        img: require("../assets/images/react.png"),
        alt: "react",
        text: "React"
    },
    {
        img: require("../assets/images/python.png"),
        alt: "python",
        text: "Python"
    },
    {
        img: require("../assets/images/cpp.png"),
        alt: "cpp",
        text: "C/C++"
    },
];


export default skills;